/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_Clients_TitleInputs */

const en_directory_mcp_clients_title = /** @type {(inputs: Directory_Mcp_Clients_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client setup`)
};

const zh_directory_mcp_clients_title = /** @type {(inputs: Directory_Mcp_Clients_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客户端配置`)
};

/**
* | output |
* | --- |
* | "Client setup" |
*
* @param {Directory_Mcp_Clients_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_clients_title = /** @type {((inputs?: Directory_Mcp_Clients_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_Clients_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_clients_title(inputs)
	return zh_directory_mcp_clients_title(inputs)
});
export { directory_mcp_clients_title as "directory.mcp.clients_title" }